import { Button, Dropdown } from "react-bootstrap";
import "./unitprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import { ReactSVG } from "react-svg";

interface UnitProfileHeaderProps {
  selectedUnitData: any;
  updateStatus: () => void;
  toggleModal: () => void;
  isEditPermitted?: boolean;
  isDeletePermitted?: boolean;
  isInactivePermitted?: boolean;
}

const UnitProfileHeader: React.FC<UnitProfileHeaderProps> = ({
  selectedUnitData,
  updateStatus,
  toggleModal,
  isEditPermitted = true,
  isDeletePermitted = true,
  isInactivePermitted = true,
}) => {
  return (
    <div className="user-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{selectedUnitData.unitCode}</h2>
        <div
          className={`status-box 
          ${selectedUnitData?.isActive ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          {selectedUnitData?.isActive ? "Active" : "Inactive"}
        </div>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href="/edit-unit">
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        <Dropdown>
          {(isDeletePermitted || isInactivePermitted) && (
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            {isDeletePermitted && (
              <Dropdown.Item onClick={toggleModal}>
                <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                Delete
              </Dropdown.Item>
            )}
            {isInactivePermitted && (
              <Dropdown.Item
                onClick={() => {
                  updateStatus();
                }}
              >
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={deactivateicon}
                />
                {selectedUnitData.isActive ? "Deactivate" : "Activate"}
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default UnitProfileHeader;
